import { jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames, d as EGDSContextProvider } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-banner.css';

const getClassNameList = classNames.bind(styles);
const EGDSBanner = (props) => {
    const { children, fullWidth, theme, domRef } = props;
    const baseClass = 'uitk-banner';
    const layoutPropsToCssClassNamesMap = new Map([
        ['contentHasFullWidth', 'full-width-content'],
        ['bannerHasFullWidth', 'full-width'],
    ]);
    const fullWidthClassName = (prop) => Object.entries(prop)
        .filter(([_, value]) => value)
        .map(([key]) => `${baseClass}-${layoutPropsToCssClassNamesMap.get(key)}`)
        .join(' ');
    const fullWidthPropValueIsObject = typeof fullWidth === 'object';
    const wrapperClassNames = getClassNameList(baseClass, {
        [fullWidthPropValueIsObject ? fullWidthClassName(fullWidth) : `${baseClass}-full-width`]: fullWidth,
        [`${baseClass}-${theme}`]: theme,
    });
    const fullWidthContentWrapperClassNames = getClassNameList(`${baseClass}-full-width-content-wrapper`);
    const fullWidthContentWrapper = (fullWidthChildren) => {
        const isFullWidthBanner = (fullWidthPropValueIsObject && fullWidth.bannerHasFullWidth) || fullWidth;
        const childCount = React.Children.count(fullWidthChildren);
        return isFullWidthBanner && childCount > 1 ? (jsx("div", { className: fullWidthContentWrapperClassNames, children: fullWidthChildren })) : (jsx(Fragment, { children: fullWidthChildren }));
    };
    return children ? (jsx("div", { className: wrapperClassNames, ref: domRef, children: jsx(EGDSContextProvider, { config: {
                context: null,
                data: {
                    contextClassNames: {
                        EGDSHeading: `${getClassNameList('uitk-banner-header')}`,
                        EGDSText: `${getClassNameList('uitk-banner-description')}`,
                        EGDSIcon: `${getClassNameList('uitk-banner-icon')}`,
                        EGDSLink: `${getClassNameList('uitk-banner-link')}`,
                    },
                },
            }, children: fullWidthContentWrapper(children) }) })) : null;
};
EGDSBanner.displayName = 'EGDSBanner';
EGDSBanner.defaultProps = {
    theme: 'critical',
};

export { EGDSBanner as E };
//# sourceMappingURL=index-chunk.esm.js.map
